import React, { createContext, useContext, useState } from 'react';

const RouteHistoryContext = createContext();

export const RouteHistoryProvider = ({ children }) => {
  const [previousRoute, setPreviousRoute] = useState(null);
  const [fromQuickAll, setFromQuickAll] = useState(false);
  const [firstAfterQuickAll, setFirstAfterQuickAll] = useState(null);

  return (
    <RouteHistoryContext.Provider
      value={{
        previousRoute,
        setPreviousRoute,
        fromQuickAll,
        setFromQuickAll,
        firstAfterQuickAll,
        setFirstAfterQuickAll,
      }}
    >
      {children}
    </RouteHistoryContext.Provider>
  );
};

export const useRouteHistory = () => useContext(RouteHistoryContext);

